import { cn } from '../../lib/utils';

const Table = ({ className, children, ...props }) => {
  return (
    <div className="w-full overflow-auto">
      <table
        className={cn('w-full caption-bottom text-sm', className)}
        {...props}
      >
        {children}
      </table>
    </div>
  );
};

const TableHeader = ({ className, children, ...props }) => {
  return (
    <thead className={cn('[&_tr]:border-b', className)} {...props}>
      {children}
    </thead>
  );
};

const TableBody = ({ className, children, ...props }) => {
  return (
    <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props}>
      {children}
    </tbody>
  );
};

const TableRow = ({ className, children, ...props }) => {
  return (
    <tr
      className={cn(
        'border-b border-border transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted',
        className
      )}
      {...props}
    >
      {children}
    </tr>
  );
};

const TableHead = ({ className, children, ...props }) => {
  return (
    <th
      className={cn(
        'h-12 px-4 text-left align-middle font-medium text-muted-foreground',
        '[&:has([role=checkbox])]:pr-0',
        className
      )}
      {...props}
    >
      {children}
    </th>
  );
};

const TableCell = ({ className, children, ...props }) => {
  return (
    <td
      className={cn(
        'p-4 align-middle [&:has([role=checkbox])]:pr-0',
        className
      )}
      {...props}
    >
      {children}
    </td>
  );
};

const TableEmpty = ({ colSpan = 1, message = 'No data available', className }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className={cn('h-24 text-center text-muted-foreground', className)}>
        {message}
      </TableCell>
    </TableRow>
  );
};

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, TableEmpty };
